import { render, staticRenderFns } from "./roleSetting.vue?vue&type=template&id=ebc6a0f2&scoped=true"
import script from "./roleSetting.vue?vue&type=script&lang=js"
export * from "./roleSetting.vue?vue&type=script&lang=js"
import style0 from "./roleSetting.vue?vue&type=style&index=0&id=ebc6a0f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc6a0f2",
  null
  
)

export default component.exports